export default __webpack_public_path__ + "static/media/FichaVisita_MakersUnit_2024.199e23fb.pdf";